import type { OriginalItemTypes } from "./types";

export type SubskillAssessment = {
	name?: string;
	score?: number;
};

export type AIFeedbackResponse = {
	explanation?: string;
	transcription?: string;
	subskillAssessments?: SubskillAssessment[];
	score?: number;
	runDetails?: {
		assistantId?: string;
		runId?: string;
		threadId?: string;
	};
	feedback?: string;
	rating?: string;
	itemType: OriginalItemTypes;
	retries?: number;
	answer?: string;
};

export type AIResponsePayload = {
	feedback: string;
	subskillAssessments: SubskillAssessment[];
	ai_run_id: string;
	ai_thread_id: string;
	metadata: {
		assistantId: string;
	};
	answer?: string;
};
